// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { Zone } from '../../SagaBase/Zone';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class ZoneDB_abstract extends Zone {
  static $t: string = 'SagaBase.ZoneDB';
  $t: string = 'SagaBase.ZoneDB';

  public static GetMembers(): string[] {
    return ['GeoSectorUid', 'MapLayerId', 'Stack_Top', 'SiteId', 'TreeTypeId'].concat(Zone.GetMembers());
  }

  public GetMembers(): string[] {
    return ZoneDB_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public GeoSectorUid: Guid = GuidTools.Empty;
  public MapLayerId: number = 0;
  public Stack_Top: number = 0;
  public SiteId: number = 0;
  public TreeTypeId: number = 0;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
